export default "__VITE_ASSET__C$eg0wuz__"